class App {
  constructor(config) {
    this.reCaptchaActive = config.reCaptchaActive;
    $("#username").rut();
    document.getElementById('username').addEventListener("keypress", e => {
      this.submitLogin(e);
    });
    document.getElementById('password').addEventListener("keypress", e => {
      this.submitLogin(e);
    });
    document.getElementById("submitLoginButton").addEventListener("click", () => {
      this.submitLogin();
    });
  }

  submitLogin(event) {
    if (event == undefined || event.keyCode == 13) {
      document.querySelector("#submitLoginButton").disabled = true;

      if (document.getElementById('username').reportValidity() && document.getElementById('password').reportValidity()) {
        if (this.reCaptchaActive) {
          grecaptcha.execute();
        } else {
          onSubmit(); //fn global
        }
      } else {
        document.querySelector("#submitLoginButton").disabled = false;
      }
    }
  }

}

new App(config);